import React, { Component } from 'react'
import { Tooltip, Button } from 'stylist'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import {
  TooltipText,
  TooltipLink,
  UpgradeLink
} from '../constants/appConstants'

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export default class ProTooltip extends Component {
  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    displayUpgradeButton: PropTypes.bool,
    portal: PropTypes.bool,
    position: PropTypes.string,
    renderTrigger: PropTypes.object,
    showOnHover: PropTypes.bool,
    title: PropTypes.string,
    tooltipType: PropTypes.string,
    transparency: PropTypes.number,
    wide: PropTypes.bool,
    wrapperClassName: PropTypes.string
  }

  static defaultProps = {
    wide: true,
    transparency: 1.0,
    color: 'darkOcean',
    title: 'Free Account',
    position: 'bottom-left',
    labelText: 'DEFAULT',
    displayUpgradeButton: true,
    showOnHover: false,
    portal: true
  }

  handleHelpRedirect = () => {
    window.location.href = TooltipLink[this.props.tooltipType]
  }

  handleUpgradeRedirect = () => {
    window.location.href = UpgradeLink
  }

  upgradeButton = () => {
    if (this.props.displayUpgradeButton) {
      return (
        <Button
          kind="standard"
          dark={true}
          size="sm"
          onMouseDown={this.handleUpgradeRedirect}
        >
          {I18n.t('Upgrade Now')}
        </Button>
      )
    }
  }

  renderInternalComponent = () => {
    const { InternalComponent, ...rest } = this.props.renderTrigger

    return <InternalComponent {...rest} />
  }

  render() {
    const {
      wide,
      transparency,
      color,
      title,
      position,
      showOnHover,
      tooltipType,
      portal,
      className
    } = this.props

    const label = (
      <div>
        <span> {TooltipText[tooltipType]} </span>
        <br />
        <FlexContainer>
          <a
            style={{ color: 'white', textDecoration: 'underline' }}
            onMouseDown={this.handleHelpRedirect}
          >
            {I18n.t('Learn more about this feature.')}
          </a>
          {this.upgradeButton()}
        </FlexContainer>
      </div>
    )

    return (
      <Tooltip
        portal={portal}
        position={position}
        wide={wide}
        transparency={transparency}
        color={color}
        label={label}
        title={title}
        containerOpenOnHover={showOnHover}
        render={({ hide, show, ref }) => (
          <div
            tabIndex="0"
            ref={ref}
            onClick={show}
            onBlur={hide}
            className={className}
          >
            {this.renderInternalComponent()}
          </div>
        )}
      />
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/ProTooltip.js